<template>
    <div class="order-manage">
        <div class="nav-bread">
            <router-link class="link-item" v-if="userTypeNum == 0" :to="{'name': 'productinfo'}">商品信息展示</router-link>
            <router-link class="link-item" v-else-if="userTypeNum != 3" :to="{'name': 'productinfo'}">采购中心</router-link>
            <router-link class="link-item" v-if="userTypeNum != 0 && userTypeNum != 3" :to="{'name': 'mypurchaseorder'}">我的订货单</router-link>
            <router-link class="link-item" v-if="userTypeNum == 2" :to="{'name': 'maintainrecord'}">保养记录</router-link>
            <router-link class="link-item" v-else-if="userTypeNum != 3" :to="{'name': 'orderlist'}">销售记录</router-link>
            <router-link class="link-item" v-if="userTypeNum != 2" :to="{'name': 'feiyouorderlist'}">非油订单</router-link>
            <router-link class="link-item" v-if="userTypeNum != 0 && userTypeNum != 3" :to="{'name': 'purchaseorderlist'}">采购记录</router-link>
            <router-link class="link-item" v-if="userTypeNum == 0 || userTypeNum == 1" :to="{'name': 'neworderlist'}">订单2.0</router-link>
            <router-link class="link-item" v-if="userTypeNum == 0 ||userTypeNum == -1" :to="{'name': 'OrderInSystem'}">系统内订单</router-link>
            <router-link class="link-item" v-if="userTypeNum == 0||userTypeNum == -1" :to="{'name': 'OrderServiceProvider'}">系统内服务商</router-link>
            <!-- <a class="link-item" v-if="userTypeNum == 0" to="" @click="goToPage">特种油结算</a> -->
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
    computed: {
        ...mapGetters(['userTypeNum'])
    },
    created() {
        console.log('this.user_type_num: ', this.userTypeNum);
    },
    methods: {
        goToPage() {
            // window.location.href = 'http://js.chafanbao.com/billFill.html';
            window.open("http://js.chafanbao.com/billFill.html", "_blank")
        }
    }
}
</script>

<style scoped>
.order-manage {
    margin: 0 auto;
    background-color: #f1f1f1;
}

.order-manage .nav-bread {
    width: 90%;
    margin: 0 auto;
    height: 50px;
    background-color: #f1f1f1;
    font-family: PingFangSC-Regular, Microsoft YaHei;
    padding-top: 8px;
}

.order-manage .nav-bread>.link-item {
    display: inline-block;
    padding: 10px 20px;
    text-decoration: none;
    font-size: 18px;
    color: #2a2a2a;
    line-height: 30px;
    border-radius: 8px 8px 0 0;
}

.order-manage .router-link-active {
    color: #000 !important;
    background-color: #d2f5e8;
}
</style>




// WEBPACK FOOTER //
// src/pages/orderManage/OrderManage.vue